<template>
  <div
    class="resource-title-container"
    :tabindex="0"
    role="button"
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space="handleClick"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ResourceLinkWrapper',
  props: {
    link: {
      type: [String, Object],
      required: true,
    },
    openInNewTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hrefLink() {
      return this.$router.resolve(this.link).href
    },
  },
  methods: {
    handleClick() {
      if (this.link) {
        if (this.openInNewTab) {
          window.open(this.hrefLink, '_blank')
        } else {
          this.$router.push(this.link)
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.resource-title-container:has(.title-content) {
  @apply flex flex-col;
}
</style>
